import gql from 'graphql-tag';

export const beneficiariesDocsStatusQuery = gql`
  query BeneficiariesDocsStatusQuery($companyProfileId: ID!) {
    companyLegalBeneficiaries(companyProfileId: $companyProfileId) {
      companyLegalBeneficiaryId
      firstName
      lastName
      onboardingStatus
      invitation {
        companyInvitationId
        canResendInvite
        inviteeEmail
        slug
        updatedAt
      }
      isCurrentUser
      updatedAt
    }
  }
`;

export const createPhysicalPersonLegalBeneficiaryMutation = gql`
  mutation createPhysicalPersonLegalBeneficiary(
    $input: CreatePhysicalPersonLegalBeneficiarySoloInput!
  ) {
    createPhysicalPersonLegalBeneficiary(input: $input) {
      companyLegalBeneficiaryId
      companyProfileId
      updatedAt
      invitation {
        companyInvitationId
        updatedAt
      }
    }
  }
`;

export const updateCompanyInvitationEmailAddressMutation = gql`
  mutation updateCompanyInvitationEmailAddress(
    $input: UpdateCompanyInvitationEmailInput!
  ) {
    updateCompanyInvitationEmailAddress(input: $input) {
      companyInvitation {
        companyInvitationId
        updatedAt
      }
    }
  }
`;
